<script setup lang="ts">
import type { AppTextareaEvent } from '@shared/ui/fields'

import { AppText } from '@shared/ui/typography'
import { AppTextarea } from '@shared/ui/fields'

import { useDisciplineGeneralForm } from '../model/discipline-general-form.hook'

defineOptions({
  name: 'DisciplineGeneralNotes',
})

const {
  refForm,
  setField,
} = useDisciplineGeneralForm()

const setNotes = (event: AppTextareaEvent): void => {
  setField('notes', event.value)
}
</script>

<template>
  <div class="discipline-general-notes">
    <AppText name="body1-medium">
      Note
    </AppText>
    <AppTextarea
      name="notes"
      class-name="discipline-general-notes__field"
      placeholder="Type here..."
      :value="refForm?.notes ?? ''"
      @input="setNotes"
    />
  </div>
</template>

<style scoped lang="scss" src="./DisciplineGeneralNotes.scss" />
